import {Component, OnInit} from '@angular/core';

import {CardModule} from 'primeng/card';
import {AccountService} from '../service';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {DialogsUtilsService} from '../service/utils/dialogs-utils.service';

@Component({
    selector: 'login',
    template: `
    <div class="flex flex-column justify-content-center align-items-center h-screen bg-login">
      <p-card class="login-card" styleClass="text-center">
        <ng-template pTemplate="header">
          <div class="m-2">
            <img alt="Logo" [src]="imgSrc"/>
          </div>
        </ng-template>
        @if (activatingUser) {
          <div class="flex flex-column justify-content-center">
            <span class="font-bold text-xl">{{ 'attivazioneUtenza'|translate }}</span>
            <p-progressSpinner strokeWidth="3"/>
          </div>
        }
      </p-card>
      <div>
        <div class="wave"></div>
        <div class="wave"></div>
        <div class="wave"></div>
      </div>
    </div>
	`,
    imports: [ProgressSpinnerModule, CardModule, TranslateModule],
    styleUrls: ['../login/login.component.scss']
})
export class WaitPageComponent implements OnInit {

	activatingUser = true;
	imgSrc = environment.loginLogoURL;

	constructor(private accountService: AccountService,
							private route: ActivatedRoute,
							private translate: TranslateService,
							private dialogUtils: DialogsUtilsService) {
	}

	ngOnInit() {
		const email: string = this.route.snapshot.paramMap.get('uid');
		this.accountService.activationUser(email).subscribe(() => {
			setTimeout(() => {
				this.dialogUtils.openAdviseDialog(this.translate.instant('conferma'), this.translate.instant('confermaAttivazioneUtente'), 'info')
					.subscribe(() => {
						window.location.href = environment.loginURL;
					});
			}, 4000);
		});
	}

}
